import { AxiosResponse } from 'axios';
import { Objeto } from '../../Models';
import Context from '../../context';

class Empresa {
    /* #region  GET Controller  */
    /* Sobre esta função *//**
     * Retorna as empresas por grupos
     **/
    public async GruposDeEmpresas(Token: string, MeusGrupos: boolean): Promise<AxiosResponse<Array<{id: number, descricao: string, empresas: Array<Objeto.Empresa>}>>> {
        return await Context.get(`/Empresa/GruposDeEmpresas/NzAyNjEyMzExNDYkYzI5ekpHNWxkRE15?MeusGrupos=${MeusGrupos}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Autoriza a pessoa, atrelada ao usuário, o acesso a uma determinada empresa
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {number} Pessoa Informe o código da pessoa (Id). Esta pessoa deverá estar cadastrada como um usuário do sistema!
     **/
    public async AutorizarPermissaoDeAcesso(Token: string, Empresa: number, Pessoa: number): Promise<AxiosResponse<any>> {
        return await Context.post(`/Empresa/AutorizarPermissaoDeAcesso/${Token}/${Empresa}/${Pessoa}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */
};

export default new Empresa();